module.exports = __webpack_public_path__ + "img/phone.e15790dc.svg";